import React, { Component } from 'react'
import Loader from 'components/loader/loader'
import { Link } from 'react-router-dom'
import yup from 'yup'
import { connect } from 'react-redux'

import { passwordRecover } from 'state/actions'
import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import SmoothCollapse from 'react-smooth-collapse'

class RecoverPassword extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isLoading: false,
			email: '',
		}
	}

	updateField = e => {
		this.setState({
			[e.target.name]: e.target.value,
		})
	}

	handleFormSubmit = async e => {
		e.preventDefault()

		const {
			passwordRecover,
			handleError,
			handleSuccess
		} = this.props

		const emailSchema = yup.object().shape({
			email: yup
			.string()
			.email('The email supplied is not valid')
			.required('Please enter an email address'),
		})

		try {
			await emailSchema.validate({ ...this.state })
		} catch (error) {
			return handleError(error.message)
		}

		this.setState({
			isLoading: true,
		})

		const { email } = this.state

		passwordRecover({ email }, (error, response) => {
			this.setState({
				isLoading: false,
			})

			if (error) {
				handleError(error.message)
				return
			}

			if (response.ok) {
				handleSuccess(response.message)
				this.setState({
					email: '',
				})
			}
		})
	}

	render() {
		const {
			isLoading,
			email
		} = this.state

		let formClass = 'auth-fields'

		if (isLoading) {
			formClass += ' faded'
		}

		const {
			validateResponse,
			handleDismiss
		} = this.props

		return (
			<div>
				<h1>
					Forgot your password?
				</h1>
				<Loader 
					visible={isLoading} 
					noText={true}
				/>
				<form onSubmit={this.handleFormSubmit} noValidate className={formClass}>
					<SmoothCollapse expanded={!!validateResponse}>
						<ValidateResponse 
							dismissCallback={handleDismiss} 
							response={validateResponse} 
							timeout={5000} 
					/>
					</SmoothCollapse>
					<input 
						value={email} 
						onChange={this.updateField} 
						placeholder="Email address" 
						name="email" 
						type="email" 
					/>
					<button className="button huge" type="submit">
						Submit
					</button>
					<span className="auth-swap">
						Back to <Link to="/auth/login">login</Link>?
					</span>
				</form>
			</div>
		)
	}
}

const RecoverPasswordWithValidation = withValidateResponse(RecoverPassword)

export default connect(null, { passwordRecover })(RecoverPasswordWithValidation)
